import React from 'react'
import { CalendarClock } from 'lucide-react'
import Badge from './ui/Badge'

const daysUntil = (iso) => Math.max(0, Math.round((new Date(iso).getTime() - Date.now()) / 86400000))
const shortDate = (iso) => new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
const IMPACT_TONE = { high: 'bear', medium: 'caution', low: 'neutral' }

export default function CatalystCalendar({ catalysts = [] }) {
  if (!catalysts.length) return null

  return (
    <div className="onds-card p-5 md:p-6">
      <div className="flex items-center gap-2 mb-4">
        <CalendarClock className="h-5 w-5" style={{ color: 'var(--onds-accent)' }} />
        <h2 className="text-lg font-bold">Catalyst Calendar</h2>
        <span className="text-sm text-[var(--onds-text-dim)]">events that can move the mandate</span>
      </div>

      <div className="relative pl-6">
        <div className="absolute left-2 top-1 bottom-1 w-px" style={{ backgroundColor: 'var(--onds-border)' }} />
        <div className="flex flex-col gap-4">
          {catalysts.map((c) => (
            <div key={c.id} className="relative">
              <div className="absolute -left-[18px] top-1.5 w-2.5 h-2.5 rounded-full" style={{ backgroundColor: 'var(--onds-accent)' }} />
              <div className="flex items-center justify-between gap-2 mb-0.5">
                <span className="font-semibold">{c.title}</span>
                <span className="text-xs text-[var(--onds-text-dim)] whitespace-nowrap">{shortDate(c.at)} · in {daysUntil(c.at)}d</span>
              </div>
              <div className="flex items-center gap-2 mb-1">
                <Badge tone="neutral">{c.type}</Badge>
                <Badge tone={IMPACT_TONE[c.expectedImpact] ?? 'neutral'}>{c.expectedImpact} impact</Badge>
              </div>
              <p className="text-sm text-[var(--onds-text-dim)]">{c.note}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
